import { useState } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { DropdownOption } from '@inno-ui/dropdown'
import { CalendarLineIcon, PersonOnPersonLineIcon } from '@inno-ui/icons'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useFederatedComponent } from 'modules/app-registry/hooks/useFederatedComponent'
import { useTranslation } from 'react-i18next'
import { WidgetSize } from 'shared/constants/widgets'
import { useUserContext } from 'shared/hooks/useUserContext'

import { WidgetComponent } from '../../types/widgets.types'
import { WidgetWrapper } from '../WidgetWrapper'
import { getDateRangeOptions } from './SalesGoalWidget.utils'

export const SalesGoalWidget: WidgetComponent = ({ ...widgetProps }) => {
  const { user } = useUserContext()
  const { t } = useTranslation('translation', { keyPrefix: 'widgets' })
  const { apps } = useAvailableApps()

  const dateRangeOptions = getDateRangeOptions(t)
  const [weekMonthMode, setWeekMonthMode] = useState<DropdownOption>(
    dateRangeOptions[0]
  )

  const userTeams = user?.teams ?? []
  const [team, setTeam] = useState<DropdownOption | undefined>(
    userTeams?.length
      ? {
          label: userTeams[0].name,
          value: userTeams[0].id + ''
        }
      : undefined
  )

  const { module, isLoaded, isError, missingRemoteUrl } = useFederatedComponent(
    process.env.REACT_APP_SALES_APP_DEV_PATH,
    'sales',
    './exposed',
    'salesApp'
  )
  // @ts-expect-error: dynamic import
  const { GoalWidget } =
    isLoaded && !isError && !missingRemoteUrl && module
      ? module
      : { GoalWidget: () => <></> }
  return (
    <WidgetWrapper
      {...widgetProps}
      isLoading={!isLoaded}
      contextMenuOptions={[
        {
          icon: CalendarLineIcon,
          label: weekMonthMode?.label,
          options: dateRangeOptions.map(option => ({
            label: option.label,
            isSelected: weekMonthMode?.value === option.value,
            onClick: () => setWeekMonthMode(option)
          }))
        },
        {
          icon: PersonOnPersonLineIcon,
          label: team ? 'Team ' + team.label : 'Select team',
          dropdownListProps: {
            maxHeight: '200px',
            isSearchable: userTeams.length > 5,
            listWidth: '250px',
            value: team,
            onClose: () => {},
            items: userTeams.map(team => ({
              label: team.name,
              value: team.id + ''
            })),
            onChange: val => setTeam(val as DropdownOption)
          }
        }
      ]}
    >
      <GoalWidget
        user={user}
        appPath={apps[AppId.SALES].path}
        selectedTeam={team?.value}
        weekMonthMode={weekMonthMode?.value}
        orientation={
          widgetProps.widget.size === WidgetSize.SMALL
            ? 'horizontal'
            : 'vertical'
        }
      />
    </WidgetWrapper>
  )
}
